var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3, _path4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLight = function SvgLight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 40",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 39,
    x: 0.5,
    y: 0.5,
    fill: "#F4F7FC",
    stroke: "#D2D5E1",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1 4a3 3 0 0 1 3-3h8v38H4a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EAEDF7",
    d: "M12.5 1v38"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    x: 4,
    y: 8,
    fill: "#7C88B1",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    x: 4,
    y: 13,
    fill: "#7C88B1",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    x: 4,
    y: 18,
    fill: "#7C88B1",
    rx: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13 1h47a3 3 0 0 1 3 3v4H13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EAEDF7",
    d: "M13 8.5h50"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 54,
    y: 3,
    fill: "#369AFE",
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 23,
    x: 17,
    y: 12,
    fill: "#FFF",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 20,
    y: 16,
    fill: "#242F57",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    x: 20,
    y: 21,
    fill: "#D2D5E1",
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    x: 20,
    y: 26,
    fill: "#D2D5E1",
    rx: 1
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 23,
    x: 47,
    y: 12,
    fill: "#FFF",
    rx: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 49,
    y: 16,
    fill: "#242F57",
    rx: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    x: 49,
    y: 21,
    fill: "#D2D5E1",
    rx: 1
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLight);
export default ForwardRef;